module.exports = __webpack_public_path__ + "static/media/blueStar.00389e95.webp";